<template>
  <div class="form-outline">
    <form-legend :field="field" />
    <div v-if="field_options.description" class="field-description caption mb-1">
      {{ field_options.description }}
    </div>
    <v-text-field
      v-model="fieldValue"
      dense
      :type="field.field_type"
      :rules="getFieldRules({ field, required: field.required })"
      :hint="hint"
      :disabled="isReadonly"
      :readonly="isReadonly"
      :persistent-hint="!!field_options.auto_fill"
      clearable
      outlined
      class="mt-3 mb-0"
      color="primary-action"
      @input="formUpdated"
    >
      <template v-slot:message="{ message }">
        <legend v-html="translateIfExist(message)"></legend>
      </template>
      <template v-slot:append-outer v-if="field.field_options.units">
        {{ field.field_options.units }}
      </template>
    </v-text-field>
  </div>
</template>

<script>
import formsMixin from '../formsMixin';
import FormLegend from '@/modules/forms/FormLegend.vue';

export default {
  components: { FormLegend },
  mixins: [formsMixin],
  emits: ['formUpdated'],
  props: {
    field: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    mode: { type: String, default: 'light' },
  },
  data() {
    return {
      fieldValue: this.formModel[this.field.cid] ? this.formModel[this.field.cid] : '',
    };
  },
  methods: {
    legend(message) {
      return this.$te(message) ? this.$t(message) : message;
    },
    formUpdated(value) {
      this.$emit('formUpdated', this.field.cid, value);
    },
  },
  computed: {
    hint() {
      if (this.field.field_options.auto_fill) {
        // Use own fields instead of module.forms.formbuilder fields because they don't seem to be used by the app neither
        // return 'Automatisch: ' + this.$t('forms.auto_fill.option.' + this.field.field_options.auto_fill);
        return 'Automatisch ausgefülltes Feld "' + this.$t('forms.auto_fill.option.' + this.field.field_options.auto_fill) + '"';
      }
      return this.field_options.description;
    },
    field_options() {
      return this.field.field_options ? this.field.field_options : {};
    },
    isReadonly() {
      if (this.readonly || (this.field_options.auto_fill && !this.field_options.auto_fill_mut)) {
        return true;
      }
      return false;
    },
  },
  watch: {
    formModel(newValue) {
      const value = newValue[this.field.cid] ? newValue[this.field.cid] : '';
      if (this.fieldValue != value) {
        this.fieldValue = value;
      }
    },
  },
};
</script>
